import './App.css';
import Navbar from './components/navbar';
import Footer from './components/footer'
import 'bootstrap-v4-rtl/dist/css/bootstrap.min.css';
import Helmet from "react-helmet";

function App() {
  return (
    <div>
       <Helmet>
       <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
      <link rel="manifest" href="/site.webmanifest"/>
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5"/>
      <meta name="msapplication-TileColor" content="#da532c"/>
      <meta name="theme-color" content="#ffffff"/>
    </Helmet>
     <Navbar/>
     <Footer/>
    </div>
  );
}

export default App;
